(() => {
  const MARKISE_CODES = [
    'AC112','AC117','AC118','AC119','AC121','AC212','AC218','AC219','AC220','AC221','AC223',
    'AC318','AC320','AC321','AC322','AC323','AC324','AC420','AC421','AC423','AC512','AC517','AC518','AC519','AC521','AC522','AC523','AC524','AC626','AC627','AC630','AC631','AC632',
    'PA425','PA522','PA524','PA528','PA532','PA612','PA614','PA616','PA617','PA626','PA627','PA630','PA632','PA633','PA636','PA637','PA639','PA642','PA643','PA645'
  ];
  const EZIP = {
    T30801:'Grau Weiß',T30808:'Uni Grau',T30812:'Grau Sand',T30818:'Grau Schwarz',T31701:'Weiß Perlweiß',T31708:'Grau Perlweiß',T31808:'Schwarz Grau',T31818:'Uni Schwarz',
    T70101:'Uni Weiß',T70141:'Weiß Weiß Perle',T70801:'Grau Weiß',T70805:'Grau Mandarine',T70806:'Grau Türkis',T70809:'Grau Orange',T70811:'Grau Blau',T70812:'Grau Sand',T70818:'Grau Schwarz',T70826:'Grau Karamell',T70841:'Grau Weiß Perle',T70867:'Pazifik',
    T71111:'Uni Blau',T71201:'Sand Weiß',T71203:'Sand Gelb',T71212:'Uni Sand',T71213:'Sand Bronze',T71305:'Bronze Mandarine',T71308:'Bronze Grau',T71313:'Uni Bronze',T71601:'Leinen Weiß',T71608:'Leinen Grau',T71616:'Uni Leinen',T71622:'Leinen Grün',T71701:'Perle Weiß',T71708:'Perle Grau',T71711:'Perle Marine',T71716:'Perle Leinen',T71717:'Uni Perle',T71745:'Perle Weiß Sand',T71812:'Schwarz Sand',T71813:'Schwarz Bronze',T71816:'Schwarz Leinen',T71818:'Uni Schwarz',T71848:'Schwarz Grau Leinen',T70808:'Uni Grau'
  };
  const PALETTES = [
    ['#d9d2c2','#a9a08f'],['#d9dbd8','#777d79'],['#c7b79b','#8c765b'],['#ece8dc','#b1a68d'],['#b9bec0','#686f72'],
    ['#d1c4aa','#6f6253'],['#d7d9d5','#9b9d98'],['#b7a786','#e5ddca'],['#9c9a91','#dcd8cd'],['#c8c2b5','#8f8b83']
  ];
  const hash = (s) => [...s].reduce((a,c)=>((a*33)+c.charCodeAt(0))>>>0,5381);
  const toneFromName = (name='') => {
    const n=name.toUpperCase();
    if(n.includes('SCHWARZ')) return 'SCHWARZ';
    if(n.includes('BLAU')||n.includes('MARINE')||n.includes('PAZIFIK')||n.includes('TÜRKIS')) return 'BLAU';
    if(n.includes('GRÜN')) return 'GRUEN';
    if(n.includes('ORANGE')||n.includes('MANDARINE')||n.includes('KARAMELL')) return 'ORANGE';
    if(n.includes('GELB')) return 'GELB';
    if(n.includes('SAND')||n.includes('BRONZE')||n.includes('LEINEN')) return 'BEIGE';
    if(n.includes('WEIß')||n.includes('WEISS')||n.includes('PERL')) return 'WEISS';
    return 'GRAU';
  };
  const paletteForEzip = (name) => {
    const n=name.toUpperCase();
    const map={
      SCHWARZ:'#262827',GRAU:'#777b79',WEISS:'#efefe9','WEIß':'#efefe9',SAND:'#cbbda2',BRONZE:'#8b6e4b',LEINEN:'#b8ad96',PERLE:'#d7d3c8',BLAU:'#466b84',MARINE:'#2f485c',PAZIFIK:'#4f8591','TÜRKIS':'#5c9996',GRUEN:'#58775e','GRÜN':'#58775e',GELB:'#d7b75d',ORANGE:'#c77a45',MANDARINE:'#ce7545',KARAMELL:'#a7724f'
    };
    const hits=Object.keys(map).filter(k=>n.includes(k));
    const a=map[hits[0]]||'#8a8d89', b=map[hits[1]]||a;
    return [a,b];
  };
  const fabrics=[];
  MARKISE_CODES.forEach((code,i)=>{
    const pal=PALETTES[hash(code)%PALETTES.length];
    fabrics.push({code,name:`Dessin ${code}`,collection:'MARKISE',tone:'ALL',colors:pal,pattern:(hash(code)%4),preview:'schematic'});
  });
  Object.entries(EZIP).forEach(([code,name])=>{
    fabrics.push({code,name,collection:'EZIP',tone:toneFromName(name),colors:paletteForEzip(name),pattern:(hash(code)%4),preview:'schematic'});
  });
  window.BEK_FABRIC_DATA={version:'M11.8.2-FABRIC-DATA-1',source:'VD Stoffkollektion · Stand 09/2026',count:fabrics.length,fabrics};
})();
